module.exports = __webpack_public_path__ + "static/media/earning.4283fbbe.svg";